import { useEffect, useState } from "react";
import { useNotificationContext } from "contexts/NotificationContext";
import { useParams } from "react-router-dom";
import { IDriver } from "models/driver";
import { fetchDriverByIdApi } from "api/driver";

export default function useDriverDetail() {
  const id: string = useParams().id!;
  const { showError } = useNotificationContext();
  const [openBan, setOpenBan] = useState<boolean>(false);
  const [openActivate, setOpenActivate] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openVerify, setOpenVerify] = useState<boolean>(false);
  const [data, setData] = useState<{ loading: boolean; data?: IDriver }>({
    loading: true,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id]);

  const fetchData = async () => {
    setData({ loading: true });
    const { data, error } = await fetchDriverByIdApi(id);
    if (data?.data) {
      setData({ loading: false, data: data.data });
    } else showError(error!.message);
  };

  const handleOpenBan = () => setOpenBan(true);
  const handleCloseBan = () => setOpenBan(false);
  const handleOpenActivate = () => setOpenActivate(true);
  const handleCloseActivate = () => setOpenActivate(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);
  const handleOpenVerify = () => setOpenVerify(true);
  const handleCloseVerify = () => setOpenVerify(false);

  return {
    data,
    handleCloseActivate,
    handleCloseBan,
    handleOpenActivate,
    handleOpenBan,
    handleOpenDelete,
    handleCloseDelete,
    handleOpenVerify,
    handleCloseVerify,
    openVerify,
    openActivate,
    openBan,
    openDelete,
    fetchData,
  };
}
